import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Cart.css';

const Cart = () => {
  const { cart, removeFromCart, updateQty, cartTotal, clearCart } = useCart();

  if (cart.length === 0) {
    return (
      <div className="cart-empty">
        <h3>Your cart is empty</h3>
        <Link to="/show-all-products" className="btn btn-primary">
          Browse Products
        </Link>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <h3>Shopping Cart</h3>
      <div className="cart-items">
        {cart.map((item) => (
          <div key={item._id} className="cart-item">
            <img
              src={item.image || `https://picsum.photos/seed/${item._id}/80/80`}
              alt={item.title}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://picsum.photos/seed/${item._id}/80/80`;
              }}
            />
            <div className="cart-item-details">
              <h5>{item.title}</h5>
              <p>${item.price?.toFixed(2)}</p>
              <div className="qty-controls">
                <button onClick={() => updateQty(item._id, (item.qty || 1) - 1)}>−</button>
                <span>{item.qty || 1}</span>
                <button onClick={() => updateQty(item._id, (item.qty || 1) + 1)}>+</button>
              </div>
            </div>
            <div className="cart-item-total">
              ${((item.price || 0) * (item.qty || 1)).toFixed(2)}
            </div>
            <button className="remove-btn" onClick={() => removeFromCart(item._id)}>
              Remove
            </button>
          </div>
        ))}
      </div>
      <div className="cart-footer">
        <p className="cart-total">Total: ${cartTotal.toFixed(2)}</p>
        <div className="cart-actions">
          <button className="btn btn-outline-secondary" onClick={clearCart}>
            Clear Cart
          </button>
          <Link to="/checkout" className="btn btn-primary">
            Proceed to Checkout
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cart;
